import React from "react";
import * as styles from "./autocomplete.scss";
import { translate } from "Shared/translate";
import MyMenigoIcon from "./../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
class SearchCategories extends React.PureComponent {
    render() {
        const items = this.props.categorySearchHits;
        const renderBreadCrumbs = (breadcrumbItems) => {
            return (!!breadcrumbItems &&
                breadcrumbItems.map((cat, i) => {
                    return (React.createElement("span", { className: styles.breadCrumbs, key: cat + i },
                        cat,
                        React.createElement(MyMenigoIcon, { name: "arrow" })));
                }));
        };
        const renderDisplayName = (category) => {
            return (React.createElement("span", null,
                " ",
                category.displayName,
                " (",
                category.productCount,
                " ",
                translate("/Units/UnitShortNames/st"),
                ")"));
        };
        const renderItems = (items) => {
            return (!!items &&
                items.map((item, j) => {
                    return (React.createElement("li", { key: item.displayName + j },
                        React.createElement("a", { href: item.url, "data-ticket": item.ticket, onClick: () => this.props.onItemClick(item.ticket) },
                            renderBreadCrumbs(item.breadCrumb),
                            renderDisplayName(item))));
                }));
        };
        return (React.createElement("div", { className: styles.searchCategories },
            React.createElement("h4", { className: styles.listHeader }, translate("/QuickSearch/Categories")),
            React.createElement("ul", { key: "SearchCategories" }, renderItems(items))));
    }
}
export default SearchCategories;
